import React from 'react';
import { cn } from '@/lib/utils';
import { BrandMark } from '@/components/BrandMark';

/**
 * Лёгкий индикатор маршрута: знак бренда + полоса прогресса.
 * Мало DOM, анимации через transform (GPU), без тяжёлых зависимостей.
 */
export function PageLoader({ className }) {
  return (
    <div
      className={cn(
        'flex min-h-[42vh] flex-col items-center justify-center gap-5 px-4 py-12',
        className
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="motion-safe:animate-page-loader-pop motion-reduce:animate-none" aria-hidden>
        <BrandMark size={44} />
      </div>
      <div className="h-1 w-28 overflow-hidden rounded-full bg-muted">
        <div className="h-full w-2/5 rounded-full bg-primary motion-safe:animate-page-loader-bar motion-reduce:animate-none" />
      </div>
      <span className="sr-only">Загрузка страницы</span>
    </div>
  );
}

export default PageLoader;
